export const GET_DATA_REQUEST = "GET_DATA_REQUEST";
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS";
export const GET_DATA_ERROR = "GET_DATA_ERROR";

export const FILTER_DATA_REQUEST = "FILTER_DATA_REQUEST";
export const FILTER_DATA_SUCCESS = "FILTER_DATA_SUCCESS";
export const FILTER_DATA_ERROR = "FILTER_DATA_ERROR";

export const MVP_DATA_REQUEST = "MVP_DATA_REQUEST";
export const MVP_DATA_SUCCESS = "MVP_DATA_SUCCESS";
export const MVP_DATA_ERROR = "MVP_DATA_ERROR";

export const BATTING_DATA_REQUEST = "BATTING_DATA_REQUEST";
export const BATTING_DATA_SUCCESS = "BATTING_DATA_SUCCESS";
export const BATTING_DATA_ERROR = "BATTING_DATA_ERROR";

export const BOWLING_DATA_REQUEST = "BOWLING_DATA_REQUEST";
export const BOWLING_DATA_SUCCESS = "BOWLING_DATA_SUCCESS";
export const BOWLING_DATA_ERROR = "BOWLING_DATA_ERROR";

export const BATTING2_DATA_REQUEST = "BATTING2_DATA_REQUEST";
export const BATTING2_DATA_SUCCESS = "BATTING2_DATA_SUCCESS";
export const BATTING2_DATA_ERROR = "BATTING2_DATA_ERROR";

export const BOWLING2_DATA_REQUEST = "BOWLING2_DATA_REQUEST";
export const BOWLING2_DATA_SUCCESS = "BOWLING2_DATA_SUCCESS";
export const BOWLING2_DATA_ERROR = "BOWLING2_DATA_ERROR";
